var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChartsBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6935 34.8888C42.6815 33.6515 42.0747 32.235 41.8271 30.6385C41.604 29.019 41.8048 27.6471 42.4346 26.4745L42.3602 26.5488L40.6032 24.8014L40.6775 24.727C39.5079 25.3561 38.136 25.5591 36.5395 25.3569C34.943 25.1092 33.5258 24.5017 32.2669 23.4674L33.9109 20.9207C37.2399 23.9336 40.995 23.9113 44.0534 21.3475L45.8075 23.1016C43.2436 26.1599 43.2436 29.9381 46.2536 33.2663L43.6935 34.8888Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7585 29.7752L43.7986 21.7351L45.3759 23.3125L36.6825 32.006H32.0074V36.9047H26.1821V41.7744H18.3232V39.5436H23.9514V34.6739H29.7766V29.7752H35.7585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChartsBigCircle);
export default __webpack_public_path__ + "static/media/ic_charts_big_circle.459d623c0243e9dca2ecee1689be0180.svg";
export { ForwardRef as ReactComponent };